import React from 'react'

import { STAFF_PORTAL_HOST } from '../../staff'

export default function TokenExpiredStaff() {
  return (
    <div className="ob-error">
      <h1 className="zb-heading2">Session Expired</h1>
      <div className="zb-card">
        <div className="zb-card-body">
          Your session has expired and you have been logged out of the Staff
          access portal.
        </div>
      </div>
      <p>
        <a
          href={`${STAFF_PORTAL_HOST}/internal-consent`}
          className="zb-button zb-button-primary"
        >
          Back to customer search
        </a>
      </p>
    </div>
  )
}
